// extracted by mini-css-extract-plugin
export var numpadContainer = "_nw-1";
export var phoneButton = "_nw-0";